"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newLanguageFeedKey = exports.feedKeyMap = exports.FLAT_KEY_DELIMITER = exports.FeedBase = void 0;
var FeedBase;
(function (FeedBase) {
    FeedBase["GLOBAL"] = "global";
    FeedBase["FOLLOWING"] = "following";
    FeedBase["LOCAL"] = "local";
    FeedBase["TRENDING"] = "trending";
    FeedBase["HASHTAG"] = "hashtag";
    FeedBase["CLUB"] = "club";
    FeedBase["KEYWORD"] = "keyword";
    FeedBase["AFFINITY"] = "affinity";
    FeedBase["RIDINGSTYLE"] = "ridingstyle";
    FeedBase["MENTION"] = "mention";
    FeedBase["COMBINED"] = "combined";
    FeedBase["PLACE"] = "place";
    FeedBase["USER"] = "user";
    FeedBase["FAVORITE"] = "favorite";
})(FeedBase = exports.FeedBase || (exports.FeedBase = {}));
exports.FLAT_KEY_DELIMITER = ":";
/**
 * Define each feed and its qualification name.
 */
const feedKeyMap = (k) => {
    switch (k) {
        case FeedBase.GLOBAL: {
            return (qualifierId) => [FeedBase.GLOBAL, qualifierId].join(exports.FLAT_KEY_DELIMITER);
        }
        default: {
            return (qualifierId) => [k, qualifierId].join(exports.FLAT_KEY_DELIMITER);
        }
    }
};
exports.feedKeyMap = feedKeyMap;
const newLanguageFeedKey = (languageCode) => {
    return exports.feedKeyMap(FeedBase.GLOBAL)(`new-${languageCode}`);
};
exports.newLanguageFeedKey = newLanguageFeedKey;
